// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Contact_contactPage__JMeqh {
  flex: 1 1;
  font-family: Arial, Helvetica, sans-serif;
  max-width: 1140px;
  margin: 0 auto;
  line-height: 1.6;
  padding-top: 60px;
  max-width: 100%;
}

h1 {
  font-size: 50px;
  margin-bottom: 5px;
  font-weight: normal;
}

p {
  margin: 0; /* Elimină complet marginile */
  color: #212529;
  font-size: 23px;
}

.Contact_locations__oq2MZ {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.Contact_location__bB2v5 {
  flex: 1 1;
  margin-right: 10px;
}

.Contact_phone__PxJLc {
  color: red;
  font-weight: bold;
  text-decoration: none;
}

.Contact_contactForm__TfM3\\+ {
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
}

.Contact_formGroup__\\+gbXF {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.Contact_formGroup__\\+gbXF label {
  width: 30%; /* Etichetele ocupă 30% din spațiu */
  font-size: 14px;
  text-align: left; /* Etichetele sunt aliniate la stânga */
  font-weight: bold;
}

.Contact_inputContainer__k2xL- {
  width: 100%;
}

.Contact_inputContainer__k2xL- input,
.Contact_inputContainer__k2xL- textarea {
  width: 70%; /* Input-urile ocupă 70% din spațiu */
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.Contact_inputContainer__k2xL- input:focus,
.Contact_inputContainer__k2xL- textarea:focus {
  border-color: #4a90e2; /* Schimbă culoarea la focus */
  box-shadow: 0 0 5px #4a90e2; /* Efectul de umbră */
  outline: none; /* Elimină conturul implicit al browserului */
}

.Contact_errorText__K2ES5 {
  font-size: 13px;
  color: red;
}

.Contact_errorInput__-uGJf {
  border-color: red; /* Schimbă culoarea la focus */
  box-shadow: 0 0 5px red; /* Efectul de umbră */
  outline: none; /* Elimină conturul implicit al browserului */
}

textarea {
  resize: none;
  height: 100px;
}

.Contact_submitButton__lttKQ {
  background-color: #e3050f;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
  width: 20%;
  margin-left: 29%;
  font-size: large;
}

.Contact_submitButton__lttKQ:hover {
  background-color: darkred;
}

.Contact_address__fe-E4 {
  margin-top: 20px;
  margin-bottom: 15px;
  font-size: 14px;
}

.Contact_mapsLink__xvmrn {
  display: flex; /* Flexbox pentru afișarea orizontală */
  align-items: center; /* Aliniere verticală */
  gap: 8px; /* Spațiu între iconiță și text */
  color: red; /* Culoare text */
  text-decoration: none; /* Fără subliniere */
  font-weight: bold;
  transition: opacity 0.3s ease; /* Tranziție pentru un efect mai plăcut */
}

.Contact_mapsLink__xvmrn i {
  font-size: 20px;
}

.Contact_mapsLink__xvmrn span {
  color: black;
}

.Contact_mapsLink__xvmrn:hover {
  opacity: 0.7; /* Face linkul mai palid */
}

.Contact_bottom__QcHoW {
  text-align: center;
}

/* Responsive */
@media (max-width: 768px) {
  .Contact_contactPage__JMeqh {
    margin: 0;
    padding: 0;
    padding-top: 55px;
    overflow-x: hidden;
    padding-left: 10px;
    padding-right: 10px;
  }

  .Contact_formGroup__\\+gbXF {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    box-sizing: border-box;
  }

  .Contact_inputContainer__k2xL- input,
  .Contact_inputContainer__k2xL- textarea {
    margin: 0;
    padding: 0;
    width: 100%; /* Input-urile ocupă 70% din spațiu */
    padding: 10px 0px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  .Contact_location__bB2v5 {
    margin-right: 0px;
  }

  .Contact_submitButton__lttKQ {
    margin: 0;
    width: 100%; /* Butonul ocupă întreaga lățime a containerului */
    padding: 12px 0px; /* Mai mult padding pentru un aspect mai plăcut */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Contact/Contact.module.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,yCAAyC;EACzC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS,EAAE,8BAA8B;EACzC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,UAAU,EAAE,oCAAoC;EAChD,eAAe;EACf,gBAAgB,EAAE,uCAAuC;EACzD,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,UAAU,EAAE,qCAAqC;EACjD,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB,EAAE,8BAA8B;EACrD,2BAA2B,EAAE,qBAAqB;EAClD,aAAa,EAAE,6CAA6C;AAC9D;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,iBAAiB,EAAE,8BAA8B;EACjD,uBAAuB,EAAE,qBAAqB;EAC9C,aAAa,EAAE,6CAA6C;AAC9D;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa,EAAE,uCAAuC;EACtD,mBAAmB,EAAE,uBAAuB;EAC5C,QAAQ,EAAE,iCAAiC;EAC3C,UAAU,EAAE,iBAAiB;EAC7B,qBAAqB,EAAE,oBAAoB;EAC3C,iBAAiB;EACjB,6BAA6B,EAAE,yCAAyC;AAC1E;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY,EAAE,0BAA0B;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;;IAEE,SAAS;IACT,UAAU;IACV,WAAW,EAAE,qCAAqC;IAClD,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,WAAW,EAAE,kDAAkD;IAC/D,iBAAiB,EAAE,iDAAiD;EACtE;AACF","sourcesContent":[".contactPage {\n  flex: 1;\n  font-family: Arial, Helvetica, sans-serif;\n  max-width: 1140px;\n  margin: 0 auto;\n  line-height: 1.6;\n  padding-top: 60px;\n  max-width: 100%;\n}\n\nh1 {\n  font-size: 50px;\n  margin-bottom: 5px;\n  font-weight: normal;\n}\n\np {\n  margin: 0; /* Elimină complet marginile */\n  color: #212529;\n  font-size: 23px;\n}\n\n.locations {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.location {\n  flex: 1;\n  margin-right: 10px;\n}\n\n.phone {\n  color: red;\n  font-weight: bold;\n  text-decoration: none;\n}\n\n.contactForm {\n  max-width: 600px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.formGroup {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.formGroup label {\n  width: 30%; /* Etichetele ocupă 30% din spațiu */\n  font-size: 14px;\n  text-align: left; /* Etichetele sunt aliniate la stânga */\n  font-weight: bold;\n}\n\n.inputContainer {\n  width: 100%;\n}\n\n.inputContainer input,\n.inputContainer textarea {\n  width: 70%; /* Input-urile ocupă 70% din spațiu */\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.inputContainer input:focus,\n.inputContainer textarea:focus {\n  border-color: #4a90e2; /* Schimbă culoarea la focus */\n  box-shadow: 0 0 5px #4a90e2; /* Efectul de umbră */\n  outline: none; /* Elimină conturul implicit al browserului */\n}\n\n.errorText {\n  font-size: 13px;\n  color: red;\n}\n\n.errorInput {\n  border-color: red; /* Schimbă culoarea la focus */\n  box-shadow: 0 0 5px red; /* Efectul de umbră */\n  outline: none; /* Elimină conturul implicit al browserului */\n}\n\ntextarea {\n  resize: none;\n  height: 100px;\n}\n\n.submitButton {\n  background-color: #e3050f;\n  color: white;\n  padding: 10px 15px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 10px;\n  width: 20%;\n  margin-left: 29%;\n  font-size: large;\n}\n\n.submitButton:hover {\n  background-color: darkred;\n}\n\n.address {\n  margin-top: 20px;\n  margin-bottom: 15px;\n  font-size: 14px;\n}\n\n.mapsLink {\n  display: flex; /* Flexbox pentru afișarea orizontală */\n  align-items: center; /* Aliniere verticală */\n  gap: 8px; /* Spațiu între iconiță și text */\n  color: red; /* Culoare text */\n  text-decoration: none; /* Fără subliniere */\n  font-weight: bold;\n  transition: opacity 0.3s ease; /* Tranziție pentru un efect mai plăcut */\n}\n\n.mapsLink i {\n  font-size: 20px;\n}\n\n.mapsLink span {\n  color: black;\n}\n\n.mapsLink:hover {\n  opacity: 0.7; /* Face linkul mai palid */\n}\n\n.bottom {\n  text-align: center;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .contactPage {\n    margin: 0;\n    padding: 0;\n    padding-top: 55px;\n    overflow-x: hidden;\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n\n  .formGroup {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    box-sizing: border-box;\n  }\n\n  .inputContainer input,\n  .inputContainer textarea {\n    margin: 0;\n    padding: 0;\n    width: 100%; /* Input-urile ocupă 70% din spațiu */\n    padding: 10px 0px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n  }\n\n  .location {\n    margin-right: 0px;\n  }\n\n  .submitButton {\n    margin: 0;\n    width: 100%; /* Butonul ocupă întreaga lățime a containerului */\n    padding: 12px 0px; /* Mai mult padding pentru un aspect mai plăcut */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contactPage": `Contact_contactPage__JMeqh`,
	"locations": `Contact_locations__oq2MZ`,
	"location": `Contact_location__bB2v5`,
	"phone": `Contact_phone__PxJLc`,
	"contactForm": `Contact_contactForm__TfM3+`,
	"formGroup": `Contact_formGroup__+gbXF`,
	"inputContainer": `Contact_inputContainer__k2xL-`,
	"errorText": `Contact_errorText__K2ES5`,
	"errorInput": `Contact_errorInput__-uGJf`,
	"submitButton": `Contact_submitButton__lttKQ`,
	"address": `Contact_address__fe-E4`,
	"mapsLink": `Contact_mapsLink__xvmrn`,
	"bottom": `Contact_bottom__QcHoW`
};
export default ___CSS_LOADER_EXPORT___;
